import { ReactNode } from 'react'

type EmailLinkProps = {
  email: string
  className?: string
  children?: ReactNode
}

export const EmailLink = (props: EmailLinkProps) => {
  const { email, className, children } = props

  return (
    <a
      className={ className }
      href={ `mailto:${ email }` }
    >
      { children || email }
    </a>
  )
}
